
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-studio/refine",
      function () {
        return require("private-next-pages/ad-studio/refine.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-studio/refine"])
      });
    }
  